let _ = require('lodash');

export default {
  init() {
    // JavaScript to be fired on the participations page
    $('.filter input').on('change', function() {
      // Change filters
      if($(this).attr('id') === 'all-theme' || $(this).attr('id') === 'all-niveau') {
        if($(this).is(':checked')) {
          $(this).closest('ul').find('input').not('#' + $(this).attr('id')).prop('checked', false);
        }
      } else {
        $(this).closest('ul').find('#all-theme, #all-niveau').prop('checked', false);

        if(!$(this).closest('ul').find('input:checked').length) {
          $(this).closest('ul').find('#all-theme, #all-niveau').prop('checked', true);
        }
      }
    });

    // Update participations
    let allCheckboxes = document.querySelectorAll('.filters input[type=checkbox]');
    let allParticipations = Array.from(document.querySelectorAll('.participations-item'));
    let checked = {};

    getChecked('theme');
    getChecked('niveau');

    Array.prototype.forEach.call(allCheckboxes, function (el) {
      toggleCheckbox(el);
      el.addEventListener('change', toggleCheckbox);
    });

    function toggleCheckbox(e) {
      if(e.target) {
        getChecked(e.target.name);
      } else {
        getChecked(e.name);
      }

      setVisibility();
    }

    function getChecked(name) {
      checked[name] = Array.from(document.querySelectorAll('input[name=' + name + ']:checked')).map(function (el) {
        return el.value;
      });
    }

    function setVisibility() {
      allParticipations.map(function (el) {
        let theme = checked.theme.length ? _.intersection(Array.from(el.classList), checked.theme).length : true;
        let niveau = checked.niveau.length ? _.intersection(Array.from(el.classList), checked.niveau).length : true;

        if (theme && niveau) {
          el.style.display = 'block';
        } else {
          el.style.display = 'none';
        }
      });
    }

    $('aside.fixed').remove();

    const getTop = el => el.offsetTop + (el.offsetParent && getTop(el.offsetParent));

    $('#to-filter').on('click', function() {
      $('html, body').animate({scrollTop: getTop($('.filters')[0]) - 100}, 'fast');
    });

    if(window.innerWidth < 768) {
      $(window).scroll(function() {
        if($(window).scrollTop() > getTop($('.participations-list')[0])) {
          $('#to-filter').addClass('fixed').fadeIn('fast');
        } else {
          $('#to-filter').fadeOut('fast', function() {
            $(this).removeClass('fixed');
          });
        }
      });
    }

  },
  finalize() {
    // JavaScript to be fired on the participations page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/participations.js